import React, { useState } from 'react';
import './PersonalBrandingBulletsManagement.css';

/**
 * 🎯 PERSONAL BRANDING BULLETS MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Personal Branding Widget Bullet Points nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - Einfache Bullet Points ohne Icons
 * - Text-Only-Management
 * - Add/Remove-Funktionalität
 * - Spezifische Klassennamen
 */
function PersonalBrandingBulletsManagement({
    bulletPoints,
    addBulletPoint,
    removeBulletPoint,
    updateBulletPoint,
    editData
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="personal-branding-bullets-management">
            {/* Toggle Header */}
            <div 
                className={`personal-branding-bullets-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="personal-branding-bullets-header-content">
                    <div className="personal-branding-bullets-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2 4h12M2 8h12M2 12h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            <circle cx="2" cy="4" r="1" fill="currentColor"/>
                            <circle cx="2" cy="8" r="1" fill="currentColor"/>
                            <circle cx="2" cy="12" r="1" fill="currentColor"/>
                        </svg>
                    </div>
                    <h3 className="personal-branding-bullets-header-title">Bullet Points</h3>
                    <div className="personal-branding-bullets-counter">
                        {bulletPoints?.length || 0}
                    </div>
                </div>
                <div className={`personal-branding-bullets-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="personal-branding-bullets-content">
                    {/* Add Button */}
                    <div className="add-personal-branding-bullet-section">
                        <button
                            onClick={addBulletPoint}
                            className="add-personal-branding-bullet-btn"
                        >
                            <div className="btn-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M7 3V11M3 7H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span>Add New Bullet Point</span>
                        </button>
                        <div className="add-personal-branding-bullet-hint">
                            Highlight your key qualifications and expertise
                        </div>
                    </div>

                    {/* Bullet Points Grid */}
                    {bulletPoints && bulletPoints.length > 0 && (
                        <div className="personal-branding-bullets-grid">
                            {bulletPoints.map((bullet, index) => (
                                <div key={bullet.id || index} className="personal-branding-bullet-edit-card">
                                    {/* Card Header */}
                                    <div className="personal-branding-bullet-card-header">
                                        <div className="personal-branding-bullet-card-title">
                                            <div className="personal-branding-bullet-card-number">{index + 1}</div>
                                            <span>Bullet Point</span>
                                        </div>
                                        <button
                                            onClick={() => removeBulletPoint(bullet.id)}
                                            className="personal-branding-bullet-remove-btn"
                                            title="Remove bullet point"
                                        >
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                            </svg>
                                        </button>
                                    </div>

                                    {/* Text Field */}
                                    <div className="personal-branding-bullet-content-section">
                                        <label className="personal-branding-bullet-field-label">Text</label>
                                        <textarea
                                            value={bullet.text || ''}
                                            onChange={(e) => updateBulletPoint(bullet.id, e.target.value)}
                                            placeholder="Enter bullet point text..."
                                            className="personal-branding-bullet-textarea"
                                            rows={3}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {(!bulletPoints || bulletPoints.length === 0) && (
                        <div className="personal-branding-bullets-empty-state">
                            <div className="personal-branding-bullets-empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3" opacity="0.3"/>
                                    <path d="M16 20h16M16 24h16M16 28h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
                                    <circle cx="12" cy="20" r="1.5" fill="currentColor" opacity="0.5"/>
                                    <circle cx="12" cy="24" r="1.5" fill="currentColor" opacity="0.5"/>
                                    <circle cx="12" cy="28" r="1.5" fill="currentColor" opacity="0.5"/>
                                </svg>
                            </div>
                            <h4>No Bullet Points Yet</h4>
                            <p>Click "Add New Bullet Point" to highlight your key qualifications</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default PersonalBrandingBulletsManagement;
